module.exports = __webpack_public_path__ + "static/media/mwe-white.c60f5b9f.png";